import { render, staticRenderFns } from "./resumesRecord.vue?vue&type=template&id=8e6299ae&scoped=true&"
import script from "./resumesRecord.vue?vue&type=script&lang=ts&"
export * from "./resumesRecord.vue?vue&type=script&lang=ts&"
import style0 from "./resumesRecord.vue?vue&type=style&index=0&id=8e6299ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e6299ae",
  null
  
)

export default component.exports